module.exports = __webpack_public_path__ + "img/logo-mcafee-red.a77b28fd.svg";